const React = require('react');
const {
  makeStyles,
  createStyles,
} = require('@material-ui/core/styles');
const FormControl = require('@material-ui/core/FormControl').default;
const SelectBase = require('@material-ui/core/Select').default;
const InputLabel = require('@material-ui/core/InputLabel').default;
const DropIcon = require('../../icons/Drop');
const selectProvider = require('./provider');

const useStyles = makeStyles((theme) => createStyles({
  paper: {
    backgroundColor: '#3e4044',
    color: '#a3a7ac',
  },
}));

function Select({env}) {
  const {
    select,
    label,
  } = env;
  const _control = env.control || {};
  const {
    helperText,
    ...control
  } = _control;
  const popoverClasses = useStyles();

  const placeholder = label.children;

  const _select = placeholder ? {
    ...select,
    label: placeholder,
    labelId: label.id,
  } : select;

  return (
    <div className="w rlv">
      <FormControl
        {...control}
        variant="filled"
      >
        {
          placeholder ? (
            <InputLabel
              {...label}
              shrink
              className="f16*3 ff$2*3 fw5*2 x14y-6s76*3 cF*3 cEC4C4C.Mui-error*2
                bg3e4044 ph5*2 mh-5"
            />
          ) : null
        }
        <SelectBase
          {..._select}
          className={`w hmin56 ff$2 f15*2 r8*2 ov dn o50.Mui-disabled
            (pv19|ph20|pr35|cF|o100)>.*OutlinedInput-input
            b2>.*OutlinedInput-notchedOutline*3
            (bcF.15):not[.Mui-error]>.*OutlinedInput-notchedOutline*2
            (dn|bgF0|bgF2:not[.Mui-disabled]:h|bg04.Mui-focused)>.*Select-root*2
            ff$2>.*Select-select
            (cA3A7AC|fw4|dn|(cEC4C4C|bgFF7070.05).Mui-error)>.MuiSelect-select
            cF(:not[.Mui-disabled]:h|.selected)>.MuiSelect-select
            st-4.5>fieldset ` + (select.className || '')}
          IconComponent={DropIcon}
          MenuProps={{
            className: '(dn|bg04.Mui-selected!|(cC|bg02):not[.Mui-selected]:h!)>.MuiMenuItem-root*2',
            PopoverClasses: popoverClasses,
          }}
        />
      </FormControl>
      {
        control.error ? (<div className="rlv">
          <div
            className="abs sh14 st f12 cEC4C4C fw4"
          >{helperText || 'Obligatory field'}</div>
        </div>) : null
      }
    </div>
  );
}

module.exports = selectProvider((env) => (<Select env={env}/>));
